import iconsSprite from '../../assets/svg/sprites/icons-sprite.svg';
import iconList from './iconList';

type Props = {
  ariaHidden?: boolean;
  className?: string;
  name: IconName;
  focusable?: boolean;
};

const Icon = ({ ariaHidden = true, className, name, focusable = false, ...rest }: Props) => {
  const isFocusable = focusable.toString() as 'true' | 'false';

  if (!name || !iconList.includes(name)) {
    return null;
  }

  return (
    <svg
      aria-hidden={ariaHidden}
      className={className}
      focusable={isFocusable}
      viewBox="0 0 24 24"
      fill="currentColor"
      {...rest}
    >
      <use href={`${iconsSprite}#${name}`} />
    </svg>
  );
};

export default Icon;
